import { render, staticRenderFns } from "./editor-history.vue?vue&type=template&id=5da5ca5e&"
import script from "./editor-history.vue?vue&type=script&lang=js&"
export * from "./editor-history.vue?vue&type=script&lang=js&"
import style0 from "./editor-history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports